import React from 'react';

const MatchScoreDisplay = ({ sport, scores }) => {
  const renderCricketScore = () => {
    const team1Score = scores?.runs1 ? `${scores.runs1}/${scores.wickets1} (${scores.overs1})` : '-';
    const team2Score = scores?.runs2 ? `${scores.runs2}/${scores.wickets2} (${scores.overs2})` : '-';
    
    return (
      <div className="flex flex-col justify-evenly text-sm">
        <div>{team1Score}</div>
        <div>{team2Score}</div>
      </div>
    );
  };

  const renderSimpleScore = () => {
    const team1Score = scores?.team1 ?? '-';
    const team2Score = scores?.team2 ?? '-';
    
    return (
      <div className="flex flex-col space-y-1 text-sm">
        <div>{team1Score}</div>
        <div>{team2Score}</div>
      </div>
    );
  };

  const renderSetScore = () => {
    const maxSets = 5;
    const sets = [];
    
    for (let i = 1; i <= maxSets; i++) {
      const team1Key = `set${i}Team1`;
      const team2Key = `set${i}Team2`;
      
      if (scores[team1Key] !== undefined || scores[team2Key] !== undefined) {
        sets.push({
          team1: scores[team1Key] ?? '-',
          team2: scores[team2Key] ?? '-'
        });
      }
    }

    return (
      <div className="flex flex-col space-y-1">
        <div className="flex flex-wrap gap-2 text-xs">
          {sets.map((set, index) => (
            <div key={index} className="flex flex-col items-center bg-gray-50 px-2 py-1 rounded">
              <span>Set {index + 1}</span>
              <div className="flex flex-col ">
                <span>{set.team1}</span>
                <span>{set.team2}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderScore = () => {
    switch (sport) {
      case 'Cricket':
        return renderCricketScore();
      case 'Tennis':
      case 'Volleyball':
      case 'Badminton':
      case 'Table Tennis':
        return renderSetScore();
      case 'Football':
      case 'Basketball':
      case 'Hockey':
      case 'Rugby':
        return renderSimpleScore();
      default:
        return <div className="text-sm">-</div>;
    }
  };

  return (
    <div className="flex items-center">
      <div className="bg-white px-3 py-1 rounded-md shadow-sm">
        {renderScore()}
      </div>
    </div>
  );
};

export default MatchScoreDisplay;